import {Component, inject, signal, DestroyRef} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ModalComponent} from '../../../../shared/components/modal/modal.component';
import {ToastrService} from 'ngx-toastr';
import {RuleCheckerService} from '../../../../services/store/rule-checker.service';
import {StoreEmployeeRequirementService} from '../../../../services/http/store/store-employee-requirement.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * Data required to open the delete store requirement modal.
 */
export interface EmployeeRequirementsDeleteData {
  storeId?: string;
  date: string;
}

/**
 * This component handles deleting a store requirement.
 */
@Component({
  selector: 'app-employee-requirements-delete',
  templateUrl: './employee-requirements-delete.component.html',
  styleUrls: ['./employee-requirements-delete.component.less'],
  imports: [SHARED_IMPORTS]
})
export class EmployeeRequirementsDeleteComponent {
  private storeEmployeeRequirementService = inject(StoreEmployeeRequirementService);
  private toastr = inject(ToastrService);
  private ruleCheckerService = inject(RuleCheckerService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** An identifier of a store. */
  readonly storeId = signal<string | undefined>(undefined);
  /** The Monday, from which store requirement should be deleted. */
  readonly date = signal<string>('');

  /** `True` if request to backend is in progress. */
  loading = false;

  static open(modalService: NgbModal, data: EmployeeRequirementsDeleteData): NgbModalRef {
    const modalRef = modalService.open(EmployeeRequirementsDeleteComponent);
    const instance = modalRef.componentInstance as EmployeeRequirementsDeleteComponent;
    instance.storeId.set(data.storeId);
    instance.date.set(data.date);
    return modalRef;
  }

  /**
   * Sends request to backend to delete a store requirement.
   * @param modalComponent a modal component of a store requirement form.
   */
  confirm(modalComponent: ModalComponent): void {
    this.loading = true;

    this.storeEmployeeRequirementService.deleteRequirement(this.storeId(), this.date())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                modalComponent.activeModal.close();
                this.loading = false;
                this.toastr.success('Requirements were successfully deleted');
                this.ruleCheckerService.check();
              },
              error: error => {
                this.loading = false;
                this.toastr.error(error.error.message);
              }
            });
  }
}